import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {Observable} from "rxjs";
import {OutletContentDto} from "../../model/dto/entity/outlet-content.dto";
import {OutletBlogPostFromJsonRequestDto} from "../../model/dto/entity/outlet-blog-post-from-json-request.dto";

@Injectable({
    providedIn: 'root'
})
export class OutletContentService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ol/outletContents');
    }

    /**
     * Generate a new blog post directly.
     * POST /createOutletContent/{outletId}/{ghostWriterId}?topic=...
     */
    public createOutletContent(
        outletId: number,
        outletContentTypeId: number,
        ghostWriterId: number,
        topic: string
    ): Observable<OutletContentDto> {
        const url = `${this.apiUrl}/createOutletContent/${outletId}/${outletContentTypeId}/${ghostWriterId}`;
        const params = { topic };
        return this.http.post<OutletContentDto>(url, null, { params });
    }

    /**
     * Generate a prompt for a blog post.
     * POST /generatePrompt/{outletId}/{ghostWriterId}?topic=...
     */
    public generatePrompt(
        outletId: number,
        outletContentTypeId: number,
        ghostWriterId: number,
        topic: string
    ): Observable<string> {
        const url = `${this.apiUrl}/generatePrompt/${outletId}/${outletContentTypeId}/${ghostWriterId}`;
        const params = { topic };
        // responseType text required since backend returns plain string
        return this.http.post<string>(url, null, { params, responseType: 'text' as 'json' });
    }

    /**
     * Create a blog post from a JSON payload.
     * POST /createOutletContentFromJson/{outletId}
     */
    public createOutletContentFromJson(
        request: OutletBlogPostFromJsonRequestDto
    ): Observable<OutletContentDto> {
        const url = `${this.apiUrl}/createOutletContentFromJson/${request.outletId}`;
        return this.http.post<OutletContentDto>(url, request);
    }


    /**
     * Simulate an existing blog post preview.
     * GET /simulate/{outletContentId}
     */
    public getOutletContentPreview(outletContentId: number): Observable<string> {
        return this.http.get<string>(`${this.apiUrl}/simulate/${outletContentId}`, {responseType: "text" as "json"});
    }

}